import React, { useState } from "react"
import CreatePage, { Field } from "../../../../components/CreatePage"
import { useHistory } from "react-router-dom"
import Option from "../../../../Models/forms/Option"
import Location, { defaultLocation } from "../../../../Models/CommonProps/Location"
import useLocationInput from "../../../../util/location/useLocationInput"
import useContactInput from "../../../../util/contact/useContactInput"
import Contact, { defaultContact } from "../../../../Models/CommonProps/Contact"
import NatureOfBusinessSelector from "../../../../components/NatureOfBusiness"
import { Box } from "@material-ui/core"
import { CancelButton, SubmitButton } from "../../../../components/Button/button"
import UserSignUpForm from "../UserSignUpForm/userSignUpForm"
import Snackbar from "../../../../components/Snackbar"

const SignUpForm = () => {

    const [name, setName] = useState('')
    const [website, setWebsite] = useState("")
    const [natureOfBusiness, setNatureOfBusiness] = useState<Option | null>(null)
    const [contact, setContact] = useState<Contact>(
       { ...defaultContact }
      );
    const history = useHistory();
    const [location, setLocation] = useState<Location>(
         {...defaultLocation}
      );
    const [showUserForm, setShowUserForm] = useState(false);
    const locationFields = useLocationInput(location, setLocation);
    const contactFields = useContactInput(contact, setContact);
    const [submitting, isSubmitting] = useState(false);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState<'success' | 'error'>();

    const onFormSubmit = async () => {
      setShowUserForm(true)
    }

    const companyDetails = {
            company: {
              name: name,
              location: {
                addressLine1: location.addressLine1,
                addressLine2: location.addressLine2,
                addressLine3: location.addressLine3,
                city: location.city,
                county: location.county,
                zipCode: location.zipCode,
                country: location.country,
              },
              website: website,
              blockSharing: false,
            },
            contact: {
              contactDetails: {
                phoneNumber: contact.phoneNumber,
                faxNumber: contact.faxNumber,
                email: contact.email,
                name: contact.name,
              },
            },
            natureOfBusinessId: natureOfBusiness?.value,
    }

    const fields: (string | Field)[] = [
    {
        name: "name",
        value: name,
        setTextValue: setName,
        label: "Company name",
        required: true,
    },
    ...locationFields,
    ...contactFields,
    {
        name: "website",
        value: website,
        setTextValue: setWebsite,
        label: "Website",
    },
    {
        name: "nature",
        render: () => <NatureOfBusinessSelector value={natureOfBusiness} onChange={setNatureOfBusiness} required/>,
    },
]

if(showUserForm)
    return <UserSignUpForm companyName={name} companyDetails={companyDetails}/>

    return <><CreatePage fields={fields} onSubmit={onFormSubmit} title="Create a Company" actionButtonArea={
            <Box style={{display:'flex', gap:'2', padding:'12px'}}>
            <SubmitButton disabled={submitting}/>
            <CancelButton onClick={() => history.push('/')}/>
            </Box>
        }/>
        <Snackbar open={open} hideAfter={6000} close={() => setOpen(false)} message={message} type={messageType}/>
        </>
}

export default SignUpForm;